<template>
  <div class="config-form p10">
    <el-form :model="formData" inline>
        <el-form-item >
            <CustomInput label='配置表'>
                <el-select 
                    placeholder="请选择"  
                    style="width: 220px"
                    :value="formData.t_id"
                    @input="(value)=>inputFormData('t_id', value)"
                >
                    <el-option 
                        v-for="item in t_list" 
                        :key="item.table_id"
                        :label="`${item.table_comment}(ID:${item.table_id})`" 
                        :value="item.table_id"
                    />
                </el-select>
            </CustomInput>
        </el-form-item>
    </el-form>
    <div class="btns">
        <el-button type="primary" @click="handleSearchClick">查询</el-button>
        <!-- <el-button >清空选项</el-button> -->
    </div>
  </div>
</template>

<script>
import CustomInput from '@/components/CustomInput'
export default {
    name: 'ConfigForm',
    components: {
        CustomInput
    },
    props: [ 't_list', 'formData' ],
    data() {
        return {}
    },
    computed: {},
    methods: {
        inputFormData(key, value) {
            this.$emit("update:formData", {
                ...this.formData,
                [key]: value
            })
        },
        handleSearchClick() {
            this.$emit('search-click')
        }
    }
}
</script>

<style lang="scss" scoped>
.config-form {
    background: #fff;
    border-radius: 4px;
    padding-top: 15px;
}
.btns {
    border-top: 1px solid #ccc;
    padding-top: 10px;
}
</style>